import { useShallow } from 'zustand/react/shallow';
import { useZoomStore, type ZoomState } from '@store/zoomStore';

/**
 * useZoomData(selector) — subscribe to a specific slice of zoom state.
 *
 * Each component should select only the fields it uses to avoid unnecessary
 * re-renders when unrelated state changes (the store updates frequently from
 * SDK polling, Firestore listeners, and React Query mirrors).
 *
 * Examples:
 *   const { headerContext, zoomPlatform } = useZoomData(s => ({
 *     headerContext: s.headerContext,
 *     zoomPlatform: s.zoomPlatform,
 *   }));
 *   const authorize = useZoomData(s => s.authorize);
 */
export function useZoomData<T>(selector: (state: ZoomState) => T): T {
  return useZoomStore(useShallow(selector));
}
